export const version = '0.449.0'
export const chameleonWebVersion = '0.0.0-1.0.0-4.fix-navbar-reload-page-score-2702.8561460-20240223193918'
